export const FESTIVAL_TIME_ZONE = 'America/Toronto';

const festivalDateFormatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: FESTIVAL_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

/** Date-only values must never be formatted via UTC-to-local timestamp conversion. */
export function festivalToday(now = new Date()) {
  const parts = festivalDateFormatter.formatToParts(now);
  const part = (type: string) => parts.find((item) => item.type === type)?.value ?? '';
  return `${part('year')}-${part('month')}-${part('day')}`;
}

export function festivalCalendarDate(value: string) {
  const [year, month, day] = value.split('-').map(Number);
  return new Date(year!, month! - 1, day!, 12);
}

export function festivalDateString(date: Date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export function isValidFestivalDate(value: string | undefined, today = festivalToday()) {
  return Boolean(
    value &&
    /^\d{4}-\d{2}-\d{2}$/.test(value) &&
    festivalDateString(festivalCalendarDate(value)) === value &&
    value >= today,
  );
}
